var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropbox = function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007EE5",
    d: "M12.5 0 0 8.1l8.7 7 12.5-7.8zM0 21.9l12.5 8.2 8.7-7.3-12.5-7.7zm21.2.9 8.8 7.3L42.4 22l-8.6-6.9zM42.4 8.1 30 0l-8.8 7.3 12.6 7.8zM21.3 24.4l-8.8 7.3-3.7-2.5V32l12.5 7.5L33.8 32v-2.8L30 31.7z"
  })));
};
export default SvgDropbox;